const metreFacets = [
	{ id: '2/4' },
	{ id: '3/4' },
	{ id: '4/4' },
	{ id: '5/4' },
	{ id: '6/4' },
	{ id: '7/4' },
	{ id: '3/8' },
	{ id: '5/8' },
	{ id: '6/8' },
	{ id: '7/8' },
	{ id: '9/8' },
	{ id: '10/8' },
	{ id: '12/8' },
	{ id: 'N/A' },
]

export default metreFacets
